import React from "react";

export function Elevation() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <path
        fill="none"
        stroke="black"
        strokeWidth="8" 
        d="M149.79 92.86L28.49 193.86 271.09 193.86 149.79 92.86z"
      />
      <path 
        fill="none" 
        stroke="black" 
        strokeWidth="10" 
        d="M28.51 220.14L271.51 220.14"
      />
    </svg>
  );
}
